import { render, staticRenderFns } from "./CODVerificationForm.vue?vue&type=template&id=457cb0af&scoped=true&"
import script from "./CODVerificationForm.vue?vue&type=script&lang=js&"
export * from "./CODVerificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457cb0af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('457cb0af')) {
      api.createRecord('457cb0af', component.options)
    } else {
      api.reload('457cb0af', component.options)
    }
    module.hot.accept("./CODVerificationForm.vue?vue&type=template&id=457cb0af&scoped=true&", function () {
      api.rerender('457cb0af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Automation/CODVerificationForm.vue"
export default component.exports